export default [
  {
    name: 'companyFlow',
    path: '/companyFlow/index',
    component: () => import('@/views/companyFlow/index'),
    meta: {
      title: '企业流程'
    }
  },
  {
    name: 'companyFlowReadRecord',
    path: '/companyFlow/readRecord',
    component: () => import('@/views/companyFlow/readRecord'),
    meta: {
      title: '阅读记录'
    }
  },
]
